import getGeo from '../glb/geo';

export default function () {
    return {
        geo: getGeo(),
        pageInfo: {},
        pageType: '',
        zipcode: null,
        bannerUrl: '',
        title: '',
        breadCrumb: [],
        cityInfo: null,
        countyInfo: null,
        dataList: [],
        isAgent: false,
        language: 'en',
        nearByNeigh: [],
        nearbyCities: [],
        neighInfo: {},
        pageNum: 1,
        pageTitle: '',
        paginationHTML: '',
        schoolCategoryData: [],
        schoolCount: null,
        schoolDistricts: null,
        schools: [],
        seoNearbyZipCode: null,
        sort: 'all',
        stateInfo: null,
        totalCount: 0,
        totalPage: 1,
    };
}
